<div class="container-fluid">
    <div class="row">
      <div class="col-xl-2">
        <!-- <app-side-filters  (childButtonEvent)="getData($event)" (onInitEvent)="onloadData($event)"></app-side-filters> -->
        <app-side-date-filter (childButtonEvent)="getData($event)" (onInitEvent)="onloadData($event)"></app-side-date-filter>
      </div>
      <div class="col-xl-10">
        <!-- <div class="box blue">{{msgOnButtonClick}}</div> -->
        <h1 class="page-hd">Request <i class="fa fa-angle-right hd-icon" aria-hidden="true"></i> Document Verification
        <!-- <button class="page-btn bg-theme"  (click)="exportexcel()">Export Report</button>  -->
      </h1>
        <!-- <div class="dispute-link"><a (click)="callDispute(3)" class="space1" >Dashboard  </a><span>   </span><a (click)="callDispute(1)">Disputes</a></div> -->
        <div class="content-wrap">
          <div class="table-responsive">
            <table class="ui celled table hover" id="excel-table" [dtTrigger]="dtTrigger" datatable [dtOptions]="dtOptions">
              <thead>
                <tr>
                    <th *ngFor = "let column of headers"> {{column}} </th>  
                </tr>
              </thead>
              <tbody>
                <tr *ngFor = "let data of fullData">
                    <td> {{data.id}} </td>
                    <td> {{data.first_name}} </td>
                    <td> {{data.last_name}} </td>
                    <td> {{data.stream_name}} </td>
                    <td> {{data.branch_name}} </td>
                    <td> {{data.semester}} </td>
                    <td> {{data.year}} </td>
                    <td> {{data.enroll_no}} </td>
                    <td> {{data.registerdemailid}} </td>
                    <td> {{data.registeredcontactno}} </td>
                    <td> {{data.company_name}} </td>
                    <td> {{data.paymentdate}} </td>
                    <td> {{data.totalamount}} </td>
                    <td> {{data.univamount}} </td>
                    <td> {{data.securAmt}} </td>
                    <td> {{data.gst}} </td>
                    <td> {{data.actualstatus}} </td>
                    <td> {{data.monthOfPassing}} </td>
                    <td> {{data.doc_status}} </td>
                    <td> {{data.bucket}} </td>
                    <td> {{data.closedDate}} </td>
                    <td> {{data.transactionId}} </td>
                    <td> {{data.remark}} </td>
                  </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>